<section class="main-bg " style="background: url('./assets/images/others/06.jpg') no-repeat 0 0; background-attachment: fixed; background-size:cover; ">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 mb-lg-0 mb-5">
                <app-title-section [titleSectionProp]="titleSectionProp"></app-title-section>
                <div class="iq-list iq-two-column">
                    <ul class="iq-list-with-icon">
                        <li *ngFor="let language of Languages" class="text-white"><i class="ion ion-checkmark-round"></i>{{ language.title | translate}}</li>
                    </ul>
                </div>
                <div class="iq-btn-container mt-4">
                    <a class="iq-button iq-btn-medium iq-btn-round iq-btn-flat d-inline" (click)="redirectToCreator()">{{'DOWNLOAD_SYNC_MANAGER' | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</section>
